import { render, staticRenderFns } from "./BatchInventory.vue?vue&type=template&id=2e8e07cd&scoped=true"
import script from "./BatchInventory.vue?vue&type=script&lang=js"
export * from "./BatchInventory.vue?vue&type=script&lang=js"
import style0 from "./BatchInventory.vue?vue&type=style&index=0&id=2e8e07cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e07cd",
  null
  
)

export default component.exports